var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevLeft = function SvgChevLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13 2 7l6-6",
    stroke: "#000",
    strokeWidth: 2
  })));
};
export default SvgChevLeft;